// Past five account groups, the rest wait behind a "Show all" button.
export const GROUPS_SHOWN = 5

// The line between two account groups in one card, with the same space on both sides.
export const GROUP_DIVIDER = 'mt-7 border-t pt-7'
